/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { isElement } from "@adapptio/lib-shared";
import { isShadowRoot } from "./isShadowRoot";
import { getOwnerDocument } from "./getOwnerDocument";

export function getParentNode(element: Node | ShadowRoot | HTMLElement): Node {
	if (element.nodeName?.toLowerCase() === "html") {
		return element;
	}

	return (
		(isElement(element) && element.assignedSlot) ||
		element.parentNode ||
		(isShadowRoot(element) && element.host) ||
		getOwnerDocument(element)
	);
}
